import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TiimeLoaderModule } from '../loader';

import { ButtonComponent } from './button.component';

@NgModule({
  imports: [CommonModule, TiimeLoaderModule],
  declarations: [ButtonComponent],
  exports: [ButtonComponent]
})
export class TiimeButtonModule {}
